<app-modal-basic #modal (closed)="onClose()" dialogClass="modal-dialog-centered"
  modalContentId="modal-configurar-integracao-ailos">
  <div class="app-modal-header">
    <h4 class="modal-title">
      <i class="m-r-5 fa fa-cog"></i> Configurar Integração AILOS
    </h4>
    <button type="button" class="close basic-close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body" [formGroup]="form">
    <div class="row" *ngIf="loading['dados']">
      <div class="col">
        Carregando...
      </div>
    </div>

    <ng-container *ngIf="!loading['dados']">
      <!-- Edson não quer tratar BolePix nesse momento.
       Está tudo feito, era só ativar na conta para testar.
       Vou deixar o resto do código ativado.
       Quando ativar, verificar o botão Salvar. -->
      <!-- <div class="row mt-3" *ngIf="form.get('apiAtiva').value">
        <div class="col">
          <app-dim-checkbox formControlName="ailosBolePix" label="Ativar BolePix" tooltipIcon="fa fa-info-circle"
            tooltipPlacement="right"
            tooltip="Quando ativado, o BolePix permite que o pagamento do boleto seja feito pelo QRCode Pix.
          Essa configuração será aplicada nos próximos boletos registrados.
          Para isso, a funcionalidade deve estar habilitada na conta Ailos e possuir uma Chave Aleatória Pix cadastrada."
            [disabled]="loading['salvarConfiguracaoApiAilos']"></app-dim-checkbox>
        </div>
      </div> -->

      <div class="row mt-3">
        <div class="col">
          <p>Essa integração permite que sejam emitidos boletos via API de Cobrança Ailos.</p>
          <p>
            Para o correto funcionamento é necessário que a API de Cobrança esteja habilitada em sua
            conta bancária, isso pode ser feito na sua agência ou pelo WhatsApp.
          </p>

          <p class="mt-2">
            <a href="https://www.youtube.com/watch?v=0iYyhVd45gQ" target="_blank" rel="noopener noreferrer">
              <i class="ti-control-play m-r-5 m-r-5"></i>
              Veja tutorial de como configurar sua integração
            </a>
          </p>
          
          <p class="mt-2 alert alert-success" *ngIf="form.get('apiAtiva').value && form.get('ambiente').value === 'H'">
            O ambiente de Homologação está ativo nesta conta.
          </p>
          <p class="mt-2 alert alert-success" *ngIf="form.get('apiAtiva').value && form.get('ambiente').value === 'P'">
            O ambiente de Produção está ativo nesta conta.
          </p>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-primary" (click)="ativarApiAilos(AilosApiAmbiente.HOMOLOGACAO)" type="button"
            *ngIf="!form.get('apiAtiva').value" [disabled]="loading['salvarConfiguracaoApiAilos']">
            Ativar Homologação
          </button>
          <button class="btn btn-primary" (click)="ativarApiAilos(AilosApiAmbiente.PRODUCAO)" type="button"
            *ngIf="!form.get('apiAtiva').value || form.get('ambiente').value === 'H'"
            [disabled]="loading['salvarConfiguracaoApiAilos']">
            Ativar Produção
          </button>

          <button class="btn btn-danger" [disabled]="loading['registro']" (click)="desativarApiAilos()" type="button"
            *ngIf="form.get('apiAtiva').value && !loading['salvarConfiguracaoApiAilos']">
            <i class="ti ti-close"></i> Desativar
          </button>

          <!-- <button class="btn btn-primary" [disabled]="loading['salvarConfiguracaoApiAilos']"
            (click)="salvarConfiguracaoApiAilos()" type="button" *ngIf="form.get('apiAtiva').value">
            <app-loading [loading]="loading['salvarConfiguracaoApiAilos']" texto="Salvar" icone="ti-save"></app-loading>
          </button> -->
          <button class="btn btn-info" (click)="onClose()" type="button"
            [disabled]="loading['salvarConfiguracaoApiAilos']">
            Cancelar
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</app-modal-basic>